import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {DrawerModule} from 'primeng/drawer';
import {DrawerService} from '../../services/drawer.service';
import {NgComponentOutlet} from '@angular/common';
import {PrimeTemplate} from 'primeng/api';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Location} from "@angular/common";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {filter} from "rxjs";

@Component({
  selector: 'homey-drawer-outlet',
  standalone: true,
  imports: [
    DrawerModule,
    NgComponentOutlet,
    PrimeTemplate
  ],
  template: `
    @let drawerState = state();
    @if (drawerState) {
      <p-drawer
        [visible]="true"
        (visibleChange)="onVisibleChange($event)"
        [modal]="true"
        [dismissible]="true"
        [blockScroll]="true"
        [closable]="true"
        position="bottom"
        [style]="bottomStyle"
        [styleClass]="(drawerState.styleClass ?? '') + ' homey-drawer-bottom'"
        [closeOnEscape]="true"
      >
        <ng-template pTemplate="header">
          @if (drawerState.header.style === 'centered') {
            <div class="w-[40px]"></div>
          }
          <div>
            <span class="text-2xl font-medium" [innerHTML]="headerHtml(drawerState.header.content)"></span>
          </div>
        </ng-template>
        <div class="homey-drawer-inner">
          <ng-container *ngComponentOutlet="drawerState.component; inputs: drawerState.inputs"></ng-container>
        </div>
      </p-drawer>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DrawerOutletComponent {
  private readonly drawerService = inject(DrawerService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly location = inject(Location);

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(),
    ).subscribe(
      () => {
        const drawerParam = this.route.snapshot.queryParamMap.get('drawer');
        if (!drawerParam || drawerParam === 'false') {
          this.drawerService.close();
        }
      }
    )
  }

  protected readonly state = this.drawerService.state;
  protected readonly bottomStyle = {
    width: '100vw',
    height: 'calc(100dvh - 2rem)',
    maxHeight: 'calc(100dvh - 2rem)',
    marginTop: '2rem',
  };

  protected headerHtml(header: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(header);
  }

  protected onVisibleChange(visible: boolean) {
    if(visible) {
      this.router.navigate([], {relativeTo: this.route, queryParams: {drawer: visible}, queryParamsHandling: 'merge'});
    } else {
      this.location.back();
    }
    if (!visible) {
      this.drawerService.close();
    }
  }
}
